import { AlertTriangleIcon, RotateCcwIcon } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { toApiError } from '@/api'

interface ErrorFallbackProps {
  error: unknown
  onReset?: () => void
  title?: string
  fullScreen?: boolean
}

export function ErrorFallback({ error, onReset, title = 'Something went wrong', fullScreen }: ErrorFallbackProps) {
  const apiError = toApiError(error)

  return (
    <div
      role="alert"
      className={
        fullScreen
          ? 'flex min-h-svh items-center justify-center p-6'
          : 'flex min-h-[50vh] items-center justify-center p-6'
      }
    >
      <div className="flex max-w-md flex-col items-center gap-4 text-center">
        <div className="flex size-12 items-center justify-center rounded-full bg-destructive/10 text-destructive">
          <AlertTriangleIcon className="size-6" />
        </div>
        <div className="space-y-1">
          <h1 className="text-lg font-semibold">{title}</h1>
          <p className="text-sm text-muted-foreground">{apiError.message}</p>
          {apiError.requestId && (
            <p className="font-mono text-xs text-muted-foreground">Request ID: {apiError.requestId}</p>
          )}
        </div>
        <div className="flex gap-2">
          {onReset && (
            <Button onClick={onReset}>
              <RotateCcwIcon data-icon="inline-start" />
              Try again
            </Button>
          )}
          <Button variant="outline" onClick={() => window.location.assign('/')}>
            Go home
          </Button>
        </div>
      </div>
    </div>
  )
}